export default __webpack_public_path__ + "static/media/navigationRight.0dc365d7.svg";